export const USER_API_PATH = 'self';
export const USER_CREATE_API_PATH = 'users';
export const USER_MARK_FOR_DELETION_API_PATH = 'user/mark_for_deletion';
export const USER_TYPE = 'user';
/**
 * List of includes available for a User
 */
export var UserIncludes;
(function (UserIncludes) {
    UserIncludes["Organization"] = "source_organization";
    UserIncludes["HealthProfile"] = "health_profile";
    UserIncludes["UserPreference"] = "user_preference";
    UserIncludes["Role"] = "roles";
})(UserIncludes || (UserIncludes = {}));
//# sourceMappingURL=helpers.js.map